import React from 'react';

export default function FilterButton({ 
  active, 
  onClick, 
  children, 
  icon: Icon,
  count 
}) {
  return (
    <button
      onClick={onClick}
      className={`
        px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2
        ${active
          ? 'bg-primary-600 text-white'
          : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
        }
      `}
    >
      {Icon && <Icon className="h-4 w-4" />}
      {children}
      {count !== undefined && (
        <span className={`
          ml-1 px-2 py-0.5 rounded-full text-xs font-semibold
          ${active ? 'bg-primary-700' : 'bg-gray-200 text-gray-700'}
        `}>
          {count}
        </span>
      )}
    </button>
  );
}
